import styled, { css } from 'styled-components';

export const Layout = styled.main`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-height: 100vh;
    min-width: 100vw;
    align-items: center;
    `;

export const Header = styled.header`
    display: flex;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.surface.high};
    width: 100%;
    flex-direction: column;
    transition: min-height 0.3s ease-in-out;
    align-items: center;
    
    @media (max-width: 1200px) {
        padding-top: calc(44px + 56px);
    }
    `;

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-height: calc(100vh - 230px);
    width: 100%;
    max-width: 1190px;

    @media (max-width: 1200px) {
        max-height: calc(100vh - 180px);
        padding-top: 16px;
    }
    
    `;

export const ContainerChild = styled(Container)`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
`;

export const ComboLayout = styled.section`
    width: 100%;
    background-color: ${({ theme }) => theme.colors.surface.high};
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.colors.border};
    @media (min-width: 1200px) {
        padding-bottom: 12px;
    }
`;

export const ComboBreadcrumbContainer = styled.ul`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0;
    list-style: none;
    width: 100%;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    padding: 24px;
    padding-top: 18px;
    padding-bottom: 16px;

    @media (min-width: 1200px) {
        padding-bottom: 22px;
    }
`;

export const ComboBreadcrumbStep = styled.li`
    align-items: center;
    display: flex;
    justify-content: flex-start;
`;

export const ComboBreadcrumbStepText = styled.span<{$active: boolean}>`
    color: ${({ $active, theme : { colors : { button : { text } } } }) => $active ? text.secondary : text.disabled };
    font-family: Inter;
    font-size: 14px;
    font-weight: ${({ $active }) => $active ? 700 : 400};
    letter-spacing: 0.016em;
    line-height: 14.52px;
    text-align: left;
`;

export const ComboBreadcrumbDotSeparator = styled.span`
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    gap: 0px;
    height: 15px;
    letter-spacing: 0.016em;
    opacity: 0.5px;
    text-align: left;
    width: 7px;
    padding-left: 8px;
    padding-right: 16px;
    color: ${({ theme }) => theme.colors.button.text.disabled};
`;

export const ComboArticleHeader = styled.article`
    padding: 24px;
    padding-top: 16px;
    gap: 12px;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};

    @media (min-width: 1200px) {
        padding-top: 22px;
    }

    & h2 {
        color: ${({ theme }) => theme.colors.text.primary};
        font-family: Inter;
        font-size: 16px;
        font-weight: 700;
        text-align: left;

        @media (min-width: 1200px) {
            font-size: 20px;
        }
    }

    & p {
        color: ${({ theme }) => theme.colors.text.secondary};
        font-family: Inter;
        font-size: 12px;
        font-weight: 400;
        text-align: left;
    }
`;

export const ComboListBtnContainer = styled.footer<{ $isFirstStep : boolean }>`
  display: flex;
  width: 100%;
  height: fit-content;
  padding: 24px;
  padding-top: 16px;
  justify-content: space-between;
  flex-direction: column-reverse;
  gap: 10px;
  
  @media (min-width: 1200px) {
    flex-direction: row;
    padding: 12px 24px;

    ${({ $isFirstStep }) => $isFirstStep && css`
        justify-content: flex-end;
    `}
  }
`;

export const ComboListButton = styled.button<{ $isBackBtn : boolean }>`
  padding: 8px 24px;
  width: 100%;
  border-radius: 100px;
  color: ${({ theme }) => theme.colors.button.text.primary};
  font-weight: 700;
  font-size: 14px;
  font-family: Inter;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ $isBackBtn }) => $isBackBtn && css`
    background-color: ${({ theme }) => theme.colors.button.surface.secondary};
    color: ${({ theme }) => theme.colors.text.primary};
    transition: background-color 0.2s;
    border: 1px solid ${({ theme }) => theme.colors.border};

    &:hover {
      background-color: ${({ theme }) => theme.colors.button.hover.secondary};
    }
  `}



  @media (min-width: 1200px) {
    width: fit-content;
  }
`;

export const ListOfCreatedCombos = styled.div`
  width: 100%;
  border-radius: 8px;
  position: relative;
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

export const CreatedComboCard = styled.section`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.surface.high};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  gap: 16px;

  & h2 {
    color: ${({ theme }) => theme.colors.text.primary};
    font-size: 20px;
    font-weight: 700;
  }
`;
